import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import Toggle from '../Toggle';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view04ImageOptions } from './views/exterior_view04'

class X56BathingPlatform extends Component {
    constructor(props) {
        super(props);
        this.handleLiftingArmChange = this.handleLiftingArmChange.bind(this);
        this.handleGangwayChange = this.handleGangwayChange.bind(this);
    }

    handleLiftingArmChange(event) {
        let configuration = this.props.configuration;
        configuration.LiftingArm = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleGangwayChange(event) {
        let configuration = this.props.configuration;
        configuration.Gangway = event.target.checked ? { value: 2, label: 'true' } : { value: 1, label: 'false' };

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = exterior_view04ImageOptions;

        let image = (
            <ConfiguratorImage boat="X5_6" configuration={this.props.configuration} options={imageOptions} />
        );

        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption>

                    <h1><Trans defaults='Bathing platform' /></h1>
                    
                    <p><Trans defaults='As standard, the bathing platform is operated electrically with two actuators, integrated attachment for “hang on” bathing ladder with teak steps and an automatic pull out ladder with teak steps to access the opened platform. If choosing flexiteek instead of teak, remember to select Flexiteek on bathing platform.' /></p>

                    <Toggle checked={this.props.configuration.LiftingArm.value === 2} onChange={this.handleLiftingArmChange}>
                        <Trans defaults='Lifting arm for RIB garage' />
                    </Toggle>

                    <Toggle checked={this.props.configuration.Gangway.value === 2} onChange={this.handleGangwayChange}>
                        <Trans defaults='Gangway' />
                    </Toggle>


                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X56BathingPlatform);


// WEBPACK FOOTER //
// ./src/X56/X56BathingPlatform.js